import { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import api, { LOGO_URL } from "../../lib/api";
import { LayoutDashboard, Package, FolderKanban, Images, BookOpen, BedDouble, ClipboardList, LogOut, ExternalLink, FileText, Calculator, Settings, Users } from "lucide-react";

const LINKS = [
  { to: "/admin", end: true, label: "Dashboard", icon: LayoutDashboard },
  { to: "/admin/products", label: "Ürünler", icon: Package },
  { to: "/admin/categories", label: "Kategoriler", icon: FolderKanban },
  { to: "/admin/slideshow", label: "Slideshow", icon: Images },
  { to: "/admin/opening-guide", label: "Açılış Rehberi", icon: BookOpen },
  { to: "/admin/room-types", label: "Oda Tipleri", icon: BedDouble },
  { to: "/admin/formulas", label: "Ekipman Formülleri", icon: Calculator },
  { to: "/admin/blog", label: "Blog", icon: FileText },
  { to: "/admin/quotes", label: "Teklifler", icon: ClipboardList },
  { to: "/admin/users", label: "Kullanıcılar", icon: Users },
  { to: "/admin/settings", label: "Ayarlar", icon: Settings },
];

export default function AdminLayout() {
  const nav = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const t = localStorage.getItem("otelpro_admin_token");
    if (!t) { nav("/admin/login"); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("otelpro_admin_token");
      nav("/admin/login");
    });
  }, [nav]);

  const logout = () => {
    localStorage.removeItem("otelpro_admin_token");
    nav("/admin/login");
  };

  if (!user) return <div className="min-h-screen flex items-center justify-center bg-softbg text-gray-500">Yükleniyor...</div>;

  return (
    <div className="flex min-h-screen bg-softbg" data-testid="admin-layout">
      <aside className="w-64 bg-navy text-white/80 flex flex-col sticky top-0 h-screen">
        <Link to="/admin" className="flex items-center gap-2 px-5 py-5 border-b border-white/10">
          <div className="bg-white/5 border border-white/10 p-1.5 rounded-md h-10 w-10 flex items-center justify-center">
            <img src={LOGO_URL} alt="" className="h-6 w-auto" />
          </div>
          <div>
            <div className="heading-serif text-white text-base">Otel Pro</div>
            <div className="text-[10px] uppercase tracking-wider text-gold">Admin</div>
          </div>
        </Link>
        <nav className="flex-1 p-3 space-y-0.5 overflow-y-auto admin-scroll">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-3 py-2.5 rounded-md text-sm transition-colors ${
                  isActive ? "bg-gold text-white" : "text-white/75 hover:bg-white/5 hover:text-gold"
                }`
              }
              data-testid={`admin-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              <l.icon size={16} /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10 space-y-1">
          <Link to="/" className="flex items-center gap-2 px-3 py-2 text-xs text-white/60 hover:text-gold" data-testid="admin-view-site">
            <ExternalLink size={12} /> Siteyi Görüntüle
          </Link>
          <div className="px-3 py-1.5 text-xs text-white/50">{user.email}</div>
          <button onClick={logout} className="flex items-center gap-2 px-3 py-2 text-xs text-white/70 hover:text-rose-400 w-full" data-testid="admin-logout">
            <LogOut size={12} /> Çıkış
          </button>
        </div>
      </aside>
      <main className="flex-1 admin-scroll overflow-x-auto">
        <Outlet />
      </main>
    </div>
  );
}
